module.exports=[
 {
   "codigo_municipio": 101,
   "2018": null,
   "2019": null,
   "2020": 1,
   "total": 1
 },
 {
   "codigo_municipio": 116,
   "2018": 1,
   "2019": null,
   "2020": null,
   "total": 1
 },
 {
   "codigo_municipio": 609,
   "2018": 1,
   "2019": null,
   "2020": null,
   "total": 1
 },
 {
   "codigo_municipio": 908,
   "2018": null,
   "2019": 1,
   "2020": null,
   "total": 1
 },
 {
   "codigo_municipio": 917,
   "2018": null,
   "2019": null,
   "2020": 1,
   "total": 1
 },
 {
   "codigo_municipio": 920,
   "2018": 1,
   "2019": null,
   "2020": null,
   "total": 1
 },
 {
   "codigo_municipio": 1001,
   "2018": 2,
   "2019": null,
   "2020": null,
   "total": 2
 },
 {
   "codigo_municipio": 1006,
   "2018": null,
   "2019": 1,
   "2020": 1,
   "total": 2
 },
 {
   "codigo_municipio": 1230,
   "2018": 1,
   "2019": null,
   "2020": null,
   "total": 1
 },
 {
   "codigo_municipio": 1301,
   "2018": 1,
   "2019": 1,
   "2020": null,
   "total": 2
 },
 {
   "codigo_municipio": 1311,
   "2018": null,
   "2019": 1,
   "2020": null,
   "total": 1
 },
 {
   "codigo_municipio": 1318,
   "2018": 2,
   "2019": null,
   "2020": null,
   "total": 2
 },
 {
   "codigo_municipio": 1408,
   "2018": null,
   "2019": null,
   "2020": 1,
   "total": 1
 },
 {
   "codigo_municipio": 1413,
   "2018": 3,
   "2019": null,
   "2020": null,
   "total": 3
 },
 {
   "codigo_municipio": 1503,
   "2018": null,
   "2019": 1,
   "2020": null,
   "total": 1
 },
 {
   "codigo_municipio": 1508,
   "2018": 1,
   "2019": null,
   "2020": 1,
   "total": 2
 },
 {
   "codigo_municipio": 1601,
   "2018": 3,
   "2019": 1,
   "2020": 1,
   "total": 5
 },
 {
   "codigo_municipio": 1703,
   "2018": 1,
   "2019": null,
   "2020": null,
   "total": 1
 },
 {
   "codigo_municipio": 1709,
   "2018": null,
   "2019": null,
   "2020": 1,
   "total": 1
 },
 {
   "codigo_municipio": 1710,
   "2018": null,
   "2019": null,
   "2020": 1,
   "total": 1
 },
 {
   "codigo_municipio": 1711,
   "2018": 1,
   "2019": null,
   "2020": null,
   "total": 1
 },
 {
   "codigo_municipio": 1712,
   "2018": null,
   "2019": 1,
   "2020": null,
   "total": 1
 },
 {
   "codigo_municipio": 1801,
   "2018": null,
   "2019": null,
   "2020": 1,
   "total": 1
 },
 {
   "codigo_municipio": 1802,
   "2018": null,
   "2019": 5,
   "2020": null,
   "total": 5
 },
 {
   "codigo_municipio": 1803,
   "2018": null,
   "2019": null,
   "2020": 1,
   "total": 1
 },
 {
   "codigo_municipio": 1804,
   "2018": null,
   "2019": 2,
   "2020": 1,
   "total": 3
 },
 {
   "codigo_municipio": 2001,
   "2018": null,
   "2019": null,
   "2020": 1,
   "total": 1
 },
 {
   "codigo_municipio": 2004,
   "2018": null,
   "2019": null,
   "2020": 1,
   "total": 1
 },
 {
   "codigo_municipio": 2005,
   "2018": 1,
   "2019": null,
   "2020": null,
   "total": 1
 },
 {
   "codigo_municipio": 2006,
   "2018": null,
   "2019": null,
   "2020": 1,
   "total": 1
 },
 {
   "codigo_municipio": 2101,
   "2018": 3,
   "2019": null,
   "2020": 1,
   "total": 4
 },
 {
   "codigo_municipio": 2102,
   "2018": null,
   "2019": 2,
   "2020": null,
   "total": 2
 },
 {
   "codigo_municipio": 2103,
   "2018": 1,
   "2019": null,
   "2020": null,
   "total": 1
 },
 {
   "codigo_municipio": 2201,
   "2018": 2,
   "2019": null,
   "2020": null,
   "total": 2
 },
 {
   "codigo_municipio": 2202,
   "2018": 1,
   "2019": null,
   "2020": null,
   "total": 1
 }
]